import script from "./ImageLightbox.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageLightbox.vue?vue&type=script&setup=true&lang=js"

import "./ImageLightbox.vue?vue&type=style&index=0&id=b7da22d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7da22d4"]])

export default __exports__